//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const MinorityDevelopersWidget = ({ count }: { count: number }) => {
  return <StatCard title='Minority Developers' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default MinorityDevelopersWidget;
